import React from 'react';
import { CollapsibleContainerBody as Component } from '@vfuk/core-collapsible-container';
const CollapsibleContainerBody = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CollapsibleContainerBody;
